module.exports = __webpack_public_path__ + "static/media/CTALeft.554f0a3b.svg";